export default __webpack_public_path__ + "static/media/Vambraces of the Hell Walker.d7b008e1.jpg";